<h2 mat-dialog-title>{{ isEdit ? 'Edit' : 'Create' }} Stat Definition</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="stats-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Category</mat-label>
      <input matInput formControlName="category" placeholder="e.g., Murder 4">
      <mat-error *ngIf="form.get('category')?.hasError('required')">
        Category is required
      </mat-error>
      <mat-error *ngIf="form.get('category')?.hasError('maxlength')">
        Category is too long
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Table</mat-label>
      <input matInput formControlName="table_name" placeholder="e.g., Achievement">
      <mat-error *ngIf="form.get('table_name')?.hasError('required')">
        Table is required
      </mat-error>
      <mat-error *ngIf="form.get('table_name')?.hasError('maxlength')">
        Table is too long
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Key</mat-label>
      <input matInput formControlName="key_name" placeholder="e.g., ACHV_STABGUNWIELDER">
      <mat-error *ngIf="form.get('key_name')?.hasError('required')">
        Key is required
      </mat-error>
      <mat-error *ngIf="form.get('key_name')?.hasError('maxlength')">
        Key is too long
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Aggregation Type</mat-label>
      <mat-select formControlName="aggregation_type">
        <mat-option value="tally">Tally (Sum)</mat-option>
        <mat-option value="average">Average</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('aggregation_type')?.hasError('required')">
        Aggregation type is required
      </mat-error>
    </mat-form-field>

    <div class="value-range">
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Min Value</mat-label>
        <input matInput type="number" formControlName="value_min" step="0.0001">
        <mat-error *ngIf="form.get('value_min')?.hasError('required')">
          Min value is required
        </mat-error>
        <mat-error *ngIf="form.get('value_min')?.hasError('pattern')">
          Min value must be a valid number
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Max Value</mat-label>
        <input matInput type="number" formControlName="value_max" step="0.0001">
        <mat-error *ngIf="form.get('value_max')?.hasError('required')">
          Max value is required
        </mat-error>
        <mat-error *ngIf="form.get('value_max')?.hasError('pattern')">
          Max value must be a valid number
        </mat-error>
        <mat-error *ngIf="form.get('value_max')?.hasError('minMaxError')">
          Max value must be greater than or equal to min value
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!form.valid">
    {{ isEdit ? 'Update' : 'Create' }}
  </button>
</mat-dialog-actions>
